/* @flow */
import React, { useContext, useRef } from "react";
import connect from "nexia_mobile/flux_like/store/connect";
import PivotPinEntryWrapper from "nexia_mobile/components/PinEntry/PivotPinEntryWrapper";
import Page from "nexia_mobile/components/Page";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import Store from "nexia_mobile/flux_like/store";
import LocalSettings, {
  AUTH_LOCKOUT_MINUTES,
  AUTH_TYPES,
} from "nexia_mobile/models/local_settings";
import traneCommercialBackground from "nexia_mobile/styl/images/trane_commercial_background.png";
import { history } from "nexia_mobile/history";
import LanguageContext from "nx-components/ContextWrappers/LanguageContext";

const styles = {
  backgroundImageStyles: {
    backgroundImage: `url(${traneCommercialBackground})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  },
};

type Props = {
  isAuthAttemptLockedOut: boolean,
};

const ValidatePinEntryPage = (props: Props) => {
  const languageContext = useContext(LanguageContext);
  const language =
    languageContext.localeSet.nexia_mobile.pages.ValidatePinEntryPage;
  let pinEntryWrapper = useRef();

  if (
    !props.isAuthAttemptLockedOut &&
    LocalSettings.getCurrentAuth() === AUTH_TYPES.FINGERPRINT &&
    Store.userCancelledFingerprint === false
  ) {
    Dispatch("VALIDATE_FINGERPRINT");
  }

  const onDone = (value) => {
    pinEntryWrapper.current.reset();
    Dispatch("VALIDATE_PIN", value);
  };

  const onForgotPin = () => {
    const prompt = `${languageContext.template(
      language.reauthPromptMessageTemplate,
      { brand: "Pivot" }
    )}:`;
    history.push("/reauth", {
      prompt,
      submitButtonText: language.reauthSubmitButton,
      title: language.reauthTitle,
      onUserAuthenticated: () => {
        Dispatch("SHOW_TOAST", language.reauthNewPinToast);
        Dispatch("PIN_RESET");
      },
    });
  };

  const { isAuthAttemptLockedOut } = props;
  const prompt = isAuthAttemptLockedOut
    ? languageContext.template(language.pinDisabledTemplate, {
        minutes: AUTH_LOCKOUT_MINUTES,
      })
    : language.enterPin;

  return (
    <Page
      name="ValidatePinEntryPage"
      backgroundImageStyles={styles.backgroundImageStyles}
      fullyLoaded
    >
      <PivotPinEntryWrapper
        ref={(inst) => (pinEntryWrapper.current = inst)}
        prompt={prompt}
        password
        length={LocalSettings.pinLength()}
        showForgotPin
        disabled={isAuthAttemptLockedOut}
        onDone={onDone}
        onForgotPin={onForgotPin}
        showEULA
      />
    </Page>
  );
};

export default connect(
  {
    isAuthAttemptLockedOut: "isAuthAttemptLockedOut",
  },
  ValidatePinEntryPage
);



// WEBPACK FOOTER //
// ./src/components/Pages/ValidatePinEntryPage.jsx